/**
 * @file schemas/standards.ts
 * @description 法規/標準庫 Zod 校驗 schema（供前端與後端共用）。
 */
import { z } from 'zod';
/**
 * 建立標準請求 schema。
 * clauses 為 JSONB 結構化條款，P0 使用 JSON textarea 輸入，M1 改為結構化編輯器。
 */
export const createStandardSchema = z.object({
    /** 標準代碼，全局唯一（如 TAP-2024） */
    code: z.string().min(1).max(100),
    /** 適用方案（如 TOP / TAP / ECO） */
    scheme: z.string().min(1).max(10),
    /** 標準全名 */
    title: z.string().min(1).max(300),
    /** 標準正文（長文本） */
    body: z.string().optional(),
    /** 結構化條款 JSON（可為 null，P0 接受任意 JSON） */
    clauses: z.unknown().optional(),
    /** 生效日期（ISO 8601） */
    effectiveAt: z.string().datetime(),
    /** 廢止日期（ISO 8601；null = 仍有效） */
    retiredAt: z.string().datetime().optional(),
});
/**
 * 更新標準請求 schema（所有欄位可選）。
 */
export const updateStandardSchema = createStandardSchema.partial();
